import React, { useRef, useCallback, useState, memo, useEffect } from "react";
import { GeoJSON, MapContainer, TileLayer } from "react-leaflet";
import "react-leaflet-fullscreen/dist";
import "react-leaflet-fullscreen/dist/styles.css";
import MapCache from "~/components/MapCache";
import LayerControlMap from "~/components/LayerControlMap";
import "./styles.scss";
import mapHelpers from '~/utils/mapHelpers';

const MAP_ZOOM = 15;

const CarMap = memo(({ areaInfo, layers, ...props }) => {
  const mapRef = useRef(null);

  const geojson = areaInfo[0].geo_json;
  const isMultiPolygon = geojson.type === 'MultiPolygon';

  const onlyXY = mapHelpers.getOnlyXY(geojson.coordinates, { isMultiPolygon });

  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  useEffect(() => {
    const bounds = mapHelpers.reverseCoordinates(onlyXY, { isMultiPolygon });

    if (!mapRef.current) {
      forceUpdate();
      return;
    }

    mapRef.current.fitBounds(bounds, {});
    mapRef.current.setMaxBounds(bounds);
  }, [forceUpdate, onlyXY, isMultiPolygon]);

  return (
    <>
      <MapContainer ref={mapRef} fullscreenControl zoom={MAP_ZOOM} {...props}>
        <TileLayer
          // attribution='&amp;copy <a href="https://www.openstreetmap.org/about">OpenStreetMap</a>'
          // url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          url="http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}"
          minZoom="10"
          subdomains={["mt0", "mt1", "mt2", "mt3"]}
        />

        <LayerControlMap key={areaInfo[0].id} layers={layers} />

        {props.areasList &&
          Array.isArray(props.areasList) &&
          props.areasList.map((area, index) => (
            <GeoJSON key={index} color="#13ffe8" data={area.geo_json} />
          ))}

        <MapCache />
      </MapContainer>
    </>
  );
});

export default CarMap;
